var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedirectStoreLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2002 3.99922C14.2002 3.55739 14.5584 3.19922 15.0002 3.19922H20.0002C20.442 3.19922 20.8002 3.55739 20.8002 3.99922V8.99922C20.8002 9.44105 20.442 9.79922 20.0002 9.79922C19.5584 9.79922 19.2002 9.44105 19.2002 8.99922V4.79922H15.0002C14.5584 4.79922 14.2002 4.44105 14.2002 3.99922Z",
    fill: "#EE741F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5659 3.43353C20.8783 3.74595 20.8783 4.25248 20.5659 4.5649L13.5659 11.5649C13.2535 11.8773 12.7469 11.8773 12.4345 11.5649C12.1221 11.2525 12.1221 10.746 12.4345 10.4335L19.4345 3.43353C19.7469 3.12111 20.2535 3.12111 20.5659 3.43353Z",
    fill: "#EE741F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8002 7.79922H10.5002C10.942 7.79922 11.3002 7.44105 11.3002 6.99922C11.3002 6.55739 10.942 6.19922 10.5002 6.19922H4.72242C4.3187 6.19922 3.93152 6.3596 3.64604 6.64507C3.36057 6.93054 3.2002 7.31772 3.2002 7.72144V19.277C3.2002 19.6807 3.36057 20.0679 3.64604 20.3534C3.93152 20.6388 4.3187 20.7992 4.72242 20.7992H16.278C16.6817 20.7992 17.0689 20.6388 17.3543 20.3534C17.6398 20.0679 17.8002 19.6807 17.8002 19.277V13.4992C17.8002 13.0574 17.442 12.6992 17.0002 12.6992C16.5584 12.6992 16.2002 13.0574 16.2002 13.4992V19.1992H4.8002V7.79922Z",
    fill: "#EE741F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectStoreLink);
export default __webpack_public_path__ + "static/media/redirect-store-link.77de13d46815b8e60898f9116493913c.svg";
export { ForwardRef as ReactComponent };